module.exports = __webpack_public_path__ + "img/ill_patterns_audio@2x.fa113bf7.png";